import { Grid } from '@mui/material';
import FormCard from 'components/FormCard';
import { FileType, FileTypeEnum, SelectOption } from 'remote/global';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { DriverCandidate } from 'utils/data/data-types';
import VehicleDocumentsForm from 'components/forms/FleetFormFactory/VehicleDocumentsForm';
import VehicleAssignDriverForm from 'components/forms/FleetFormFactory/VehicleAssignDriverForm';
import {
  useOperatorsDriverCandidatesQuery,
  useOperatorsDriversQuery,
  useOperatorsVehiclesFilesQuery,
  useOperatorsVehiclesQuery,
} from 'api/queries/operators';

function VehicleDocumentsView() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: vehicle, isSuccess: isSuccessVehicle } = useOperatorsVehiclesQuery(id!);
  const {
    data: vehicleFiles,
    isLoading: isLoadingVehicleFiles,
    isSuccess: isSuccessFiles,
  } = useOperatorsVehiclesFilesQuery(id!);
  const { data: driverCandidates, isSuccess: isSuccessDriverCandidates } =
    useOperatorsDriverCandidatesQuery();
  const { data: driver } = useOperatorsDriversQuery(
    vehicle?.defaultDriverId ? String(vehicle.defaultDriverId) : undefined
  );

  const getOptions = (): SelectOption[] => {
    if (driverCandidates == null) return [];
    const options =
      (driverCandidates as DriverCandidate[]).map((c) => ({
        label: c.value,
        value: c.id,
      })) ?? [];
    if (driver != null)
      return [
        {
          label: driver.contactInfo.fullName as string,
          value: driver.id,
        },
        ...options,
      ];
    return options;
  };

  if (!isSuccessVehicle || !isSuccessFiles || !isSuccessDriverCandidates) return null;

  const insuranceDocuments = (vehicleFiles as FileType[]).filter(
    ({ fileType }) => fileType === FileTypeEnum.VEHICLE_INSURANCE_DOC
  );
  const vehicleCards = (vehicleFiles as FileType[]).filter(
    ({ fileType }) => fileType === FileTypeEnum.VEHICLE_CARD
  );

  return (
    <Grid container gap={4}>
      <Grid item container width='421px' textAlign='left'>
        <FormCard title={t('FleetView.DetailView.vehicleDocuments.title')}>
          {/* isFilesLoading makes sure defaultValues is handled correctly */}
          {!isLoadingVehicleFiles && vehicle != null ? (
            <VehicleDocumentsForm
              vehicleId={String(vehicle.id)}
              defaultValues={{ insuranceDocuments, vehicleCards }}
            />
          ) : undefined}
        </FormCard>
      </Grid>
      <Grid item width='421px' textAlign='left'>
        <FormCard title={t('FleetView.DetailView.vehicleAssignDriver.title')}>
          {/* loading check makes sure defaultValues is handled correctly */}
          {vehicle != null ? (
            <VehicleAssignDriverForm
              options={getOptions()}
              vehicleId={String(vehicle.id)}
              defaultValues={{ defaultDriverId: vehicle?.defaultDriverId as number }}
            />
          ) : undefined}
        </FormCard>
      </Grid>
    </Grid>
  );
}

export default VehicleDocumentsView;
